module.exports = __webpack_public_path__ + "img/logo-cavp-mobile.d87bdd56.svg";